import { NotifyHelper } from "../../../helpers/toast";
import { eToolbarLopActionsObj } from "../../action-types/common/IToolbarLopActions";
import { generateActionForKey, generateActions } from "../generateActions";

export const toolbarLopActions = {
    ...generateActions(eToolbarLopActionsObj, "TOOBAR_LOP"),
}